import { render, staticRenderFns } from "./SavedViewsShortcutsBar.vue?vue&type=template&id=54b3bf5c&scoped=true&"
import script from "./SavedViewsShortcutsBar.vue?vue&type=script&lang=js&"
export * from "./SavedViewsShortcutsBar.vue?vue&type=script&lang=js&"
import style0 from "./SavedViewsShortcutsBar.vue?vue&type=style&index=0&id=54b3bf5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b3bf5c",
  null
  
)

export default component.exports